const animalEmojis = {
  ant: '🐜',
  bird: '🐦',
  blowfish: '🐡',
  boar: '🐗',
  bug: '🐛',
  camel: '🐪',
  cat: '🐈',
  chicken: '🐔',
  crocodile: '🐊',
  dog_face: '🐶',
  dogface: '🐶',
  dog: '🐕',
  doggo: '🐕',
  domestic_cat: '🐈',
  domesticcat: '🐈',
  dove: '🕊',
  elephant: '🐘',
  ewe: '🐑',
  feline: '🐈',
  frog_face: '🐸',
  frogface: '🐸',
  hamster_face: '🐹',
  hamsterface: '🐹',
  honeybee: '🐝',
  horse: '🐎',
  housecat: '🐈',
  koala: '🐨',
  leopard: '🐆',
  lion_face: '🦁',
  monkey: '🐒',
  monkey_face: '🐵',
  monkeyface: '🐵',
  mouse: '🐁',
  octopus: '🐙',
  ox: '🐂',
  penguin: '🐧',
  rabbit: '🐇',
  rabbit_face: '🐰',
  rabbitface: '🐰',
  ram: '🐏',
  roster: '🐓',
  scorpion: '🦂',
  snake: '🐍',
  snail: '🐌',
  spider: '🕷️',
  turkey: '🦃',
  turtle: '🐢',
  water_buffalo: '🐃',
  whale: '🐋'
}

module.exports = animalEmojis
